{
  "name": "@ns/collect-public-ledger-signature",
  "version": "1.0.0",
  "description": "You have been asked to sign the below public ledger transaction",
  "inputs": {
    "transactionId": {
      "type": "string"
    },
    "transactionType": {
      "type": "string"
    }
  },
  "outcomes": {
    "signed": {},
    "rejected": {
      "inputs": {
        "reason": {
          "type": "string"
        }
      }
    },
    "acknowledged": {}
  },
  "jobMetadata": [
    "SIGNATURE_SUBMISSION_WARNING",
    "PROCESSED"
  ]
}
